import React, { Component } from 'react'
import ModalFormDocumento from './Modais/ModalFormDocumento'
import { connect } from 'react-redux'
import ModalFormAgrupador from './Modais/ModalFormAgrupador'

import {
    listaDocumentos, addDados, limpa_msgs
} from '../actions/'
import ModalFormTipoAssinante from './Modais/ModalFormTipoAssinante'
import { ToastContainer, toast } from 'react-toastify'
import ModalUpdatePassword from './Modais/ModalUpdatePassword'
import ModalFormUser from './Modais/ModalFormUser'

class BarraLateral extends Component {
    constructor(){
        super()
        this.state = {
            modalIsOpen: false,
            tag: ''
        }
        this.myRef = React.createRef();
    }

    async componentWillMount(){
        this.verificaFiltro(window.location.search)
    }

    verificaFiltro(search){
        let valores = search.split('=')

        if(valores.length > 1)
            this.filtro( 'status', valores[1] || '' )

    }

    openModal() {
        this.setState({modalIsOpen: true});
    }

    closeModal() {
        this.setState({modalIsOpen: false});
    }

    filtro(por,search){
        this.props.limpa_msgs()
        if(window.location.href.includes('/config'))
            window.location.href = `/documentos${search != undefined ? '?filtro='+search : ''}`      

        const { load_doc } = this.props.documentos
        if(load_doc) return null

        let filtro = (por == undefined && search == undefined) ? null : {por,search}
        this.props.addDados({ filtroStatus: search })
        this.props.listaDocumentos({ status: search })
    }

    render() {
        const { admin, email } = this.props.auth.user
        return ( 
            <div id='barralateral'>
                <nav className="col-md-2 d-none d-md-block bg-light sidebar" style={{...styles.textDefault,...styles.background}}>
                    <div className="sidebar-sticky">
                        <ul className="nav flex-column">
                            <li className="nav-item">
                                <a  className="navbar-link" href="/documentos">
                                    <img style={styles.img} src="/assets/imagem/logo-finsol.png" className="d-inline-block align-top"  />
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link active" href="#">

                                <button className="btn btn-primary btn-block" data-toggle="modal" data-target="#modalFormDocumento">
                                    Adicionar Documento
                                </button>

                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link"  href="#" onClick={ () => this.filtro()}>
                                    <span data-feather="file" style={styles.feather}></span>
                                    Documentos
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#" onClick={ () => this.filtro('status','aberto')}>
                                    <span data-feather="refresh-cw" style={styles.feather}></span>
                                    Em Processo
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#" onClick={ () => this.filtro('status','finalizado')}>
                                    <span data-feather="check-circle" style={styles.feather}></span>
                                    Concluidos
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#" onClick={ () => this.filtro('status','cancelado')}>
                                    <span data-feather="trash" style={styles.feather}></span>
                                    Lixeira
                                </a>
                            </li>
                            {admin && <div>
                                <li className="nav-item">
                                    <a className="nav-link " href="/config/dashboard/agrupador" >
                                        <span data-feather="users" style={styles.feather}></span>             
                                        Agrupador
                                    </a>
                                </li>

                                <li className="nav-item">
                                    <a className="nav-link "  href="/config/dashboard/tipo-signatario">
                                        <span data-feather="user" style={styles.feather}></span>             
                                        Tipo Signatario
                                    </a>
                                </li>

                                <li className="nav-item" onClick={() => this.props.limpa_msgs()}>
                                    <a className="nav-link " href="/config/dashboard/usuarios">
                                        <span data-feather="user-plus" style={styles.feather}></span>             
                                        Usuários
                                    </a>
                                </li>

                                <li className="nav-item" onClick={() => this.props.limpa_msgs()}>
                                    <a className="nav-link " href="/config/admin/relatorio">
                                        <span data-feather="activity" style={styles.feather}></span>             
                                        Relatório
                                    </a>
                                </li>
                            </div>}

                            <li className="nav-item" onClick={() => this.props.limpa_msgs()}>
                                <a className="nav-link " href="#" data-toggle="modal" data-target="#modalUpdatePassword">
                                    <span data-feather="lock" style={styles.feather}></span>             
                                    Atualizar Senha
                                </a>
                            </li>

                            {/* <li className="nav-item">
                                <a className="nav-link " href="config">
                                    <span data-feather="settings" style={styles.feather}></span>             
                                    Configurações
                                </a>
                            </li> */}
                        </ul>
                    </div>                
                </nav>

                {document.querySelector('.Toastify') == null && <ToastContainer autoClose={3000} position={toast.POSITION.BOTTOM_CENTER} draggable={false}/>}
                
                <ModalFormDocumento closeModal={()=>this.closeModal()} />
                <ModalFormAgrupador closeModal={()=>this.closeModal()} />
                <ModalFormTipoAssinante closeModal={()=>this.closeModal()} />
                <ModalFormUser closeModal={()=>this.closeModal()} />
                <ModalUpdatePassword closeModal={()=>this.closeModal()} />                
        </div>
        )
    }
}

const mapStateToProps = ({ documentos, auth }) => {
    return {
        documentos, auth
    }
}

export default connect(mapStateToProps, {
    listaDocumentos, addDados, limpa_msgs
})(BarraLateral);

const styles = {
    feather: {
        width: '16px',
        height: '16px',
        verticalAlign: 'text-bottom',
        marginRight:6
    },
    textDefault:{
        fontSize: '.875rem'
    },
    background: {
        background: 'white',
        boxShadow:' 2px 2px rgba(0, 0, 0, 0.07)'
    },
    img: {
        width: '100%',
        padding: 10
    }
}